import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfModule } from '@totvs/thf-ui';

import { ThfModalPasswordRecoveryComponent } from '../thf-modal-password-recovery/thf-modal-password-recovery.component';
import { ThfPageBackgroundModule } from '../thf-page-background/index';
import { ThfPageLoginComponent } from './thf-page-login.component';
import { ThfPageLoginPopoverComponent } from './thf-page-login-popover/thf-page-login-popover.component';
import { ThfPageLoginService } from './thf-page-login.service';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-login.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ThfPageBackgroundModule,
    ThfModule
  ],
  declarations: [
    ThfPageLoginComponent,
    ThfPageLoginPopoverComponent
  ],
  entryComponents: [
    ThfModalPasswordRecoveryComponent
  ],
  exports: [
    ThfPageLoginComponent
  ],
  providers: [ThfPageLoginService]
})
export class ThfPageLoginModule { }
